export const taskTypeTemplates = [
  { id: 1, name: "checkbox" },
  { id: 2, name: "numeric" },
  { id: 3, name: "input" },
  { id: 4, name: "spotcheck" },
  { id: 5, name: "waste" },
];
